import { Box, FormLabel, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

interface Props {
  label: ReactNode;
  children: ReactNode;
  className?: string;
  color?: 'grey' | 'white';
}

const useStyles = createUseStyles((theme: Theme) => ({
  floatLabelCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    padding: 8,
    backgroundColor: theme.palette.background.default,
    '&.grey': {
      backgroundColor: theme.palette.background.sidebar,
      '& $label': {
        backgroundColor: theme.palette.background.sidebar,
      },
    },
    marginTop: 4,
  },
  label: {
    backgroundColor: theme.palette.background.default,
    position: 'absolute',
    left: 5,
    top: -10,
    fontSize: '0.75rem',
    padding: '0px 5px',
    height: 11,
  },
}));

const FloatLabelCard: FC<Props> = ({ label, children, className, color = 'white' }) => {
  const styles = useStyles();
  const compClass = classNames(styles.floatLabelCard, color, className);
  const hasLabel = !!label;
  return (
    <Box className={compClass}>
      {hasLabel && (
        <FormLabel className={`${styles.label} MuiInputLabel-sizeSmall`}>{label}</FormLabel>
      )}
      {children}
    </Box>
  );
};

export default FloatLabelCard;
